import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useModalStore = create(
  persist(
    () => ({
      couldSavePopup: false,
    }),
    {
      name: '_modal-store',
      version: 1,
      migrate: (persistedState, version: number) => {
        if (!persistedState || typeof persistedState !== 'object') {
          return persistedState;
        }

        let state = persistedState as Record<string, unknown>;

        if (version === 0) {
          // Remove the deprecated pro modal field
          const { pro, ...rest } = state;
          state = rest;
        }

        // Remove the deprecated onlineSubscriptionsPopup field from all versions
        const { onlineSubscriptionsPopup, ...cleanedState } = state;
        return cleanedState;
      },
    },
  ),
);
